<p-button icon="pi pi-arrow-left" [rounded]="true" severity="info" [outlined]="true" (click)="goBack()"/>